import ChunkProgressIndicator from './ChunkProgressIndicator';

export default ChunkProgressIndicator;
